<template>
  <b-modal
    ref="modal"
    :title="modalTitle"
    size="md"
    ok-title="Salvar"
    cancel-title="Cancelar"
    :ok-disabled="saving"
    :cancel-disabled="saving"
    @ok="onSaveClicked($event)"
    @cancel="$emit('cancel')"
  >
    <b-form>
      <b-row>
        <b-col cols="12" lg="6">
          <b-form-group label="Tipo">
            <b-form-select
              v-model="event.type"
              v-validate="rules.type"
              class="form-control"
              :options="typeOpts"
              aria-describedby="invalidType"
              name="type"
              :state="validateState('state')"
            ></b-form-select>
            <b-form-invalid-feedback id="invalidType">
              {{ errors.first("type") }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row
        v-if="
          companyClassification.complaintClosure.enabled &&
          event.type === EventType.CLOSURE
        "
      >
        <b-col>
          <b-form-group label="Indicador de Encerramento">
            <b-form-select
              v-model="event.closure"
              v-validate="rules.closure"
              class="form-control"
              :options="classificationOptions.complaintClosure"
              aria-describedby="invalidClosure"
              name="closure"
              :state="validateState('closure')"
            ></b-form-select>
            <b-form-invalid-feedback id="invalidClosure">
              {{ errors.first("closure") }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="event.type === EventType.PENDENCY">
        <b-col cols="6">
          <b-form-group label="Usuário">
            <b-form-select
              v-model="event.pendency.user"
              v-validate="rules.pendency.user"
              class="form-control"
              :options="userOpts"
              aria-describedby="invalidPendencyUser"
              name="pendencyUser"
              :state="validateState('pendencyUser')"
            ></b-form-select>
            <b-form-invalid-feedback id="invalidPendencyUser">
              {{ errors.first("pendencyUser") }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Prazo">
            <b-form-input
              v-model="event.pendency.dueDate"
              v-validate="rules.pendency.dueDate"
              class="form-control"
              type="date"
              :min="minDeadline"
              aria-describedby="invalidDeadline"
              name="deadline"
              :state="validateState('deadline')"
            ></b-form-input>
            <b-form-invalid-feedback id="invalidDeadline">
              {{ errors.first("deadline") }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="event.type === EventType.TASK">
        <b-col cols="6">
          <b-form-group label="E-mail">
            <b-form-input
              v-model="event.task.email"
              v-validate="rules.task.email"
              class="form-control"
              aria-describedby="invalidTaskEmail"
              name="taskEmail"
              :state="validateState('taskEmail')"
            ></b-form-input>
            <b-form-invalid-feedback id="invalidTaskEmail">
              {{ errors.first("taskEmail") }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Prazo">
            <b-form-input
              v-model="event.task.dueDate"
              v-validate="rules.task.dueDate"
              class="form-control"
              type="date"
              :min="minDeadline"
              aria-describedby="invalidTaskDeadline"
              name="taskDeadline"
              :state="validateState('taskDeadline')"
            ></b-form-input>
            <b-form-invalid-feedback id="invalidTaskDeadline">
              {{ errors.first("taskDeadline") }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="event.type === EventType.TIME_COST">
        <b-col cols="4">
          <b-form-group label="Tempo Gasto (minutos)">
            <b-form-input
              v-model.number="event.timeCost.timeSpent"
              v-validate="rules.timeCost.timeSpent"
              class="form-control"
              type="number"
              min="0"
              aria-describedby="invalidTimeSpent"
              name="timeSpent"
              :state="validateState('timeSpent')"
            ></b-form-input>
            <b-form-invalid-feedback id="invalidTimeSpent">
              {{ errors.first("timeSpent") }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col
          v-if="
            complaint.company &&
            complaint.company.financial &&
            complaint.company.financial.showTimeCost
          "
          cols="4"
        >
          <b-form-group label="Custo (R$) - Automático">
            <b-form-input
              :value="event.timeCost.cost"
              class="form-control"
              type="number"
              readonly
              name="cost"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" class="mt-2">
          <b-form-group label="Descrição do Trabalho">
            <b-form-textarea
              v-model="event.timeCost.description"
              v-validate="rules.timeCost.description"
              class="form-control"
              :rows="3"
              :max-rows="3"
              aria-describedby="invalidTimeCostDescription"
              name="timeCostDescription"
              :state="validateState('timeCostDescription')"
            ></b-form-textarea>
            <b-form-invalid-feedback id="invalidTimeCostDescription">
              {{ errors.first("timeCostDescription") }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Novo tipo: Determinação de Curso Obrigatório -->
      <b-row v-if="event.type === EventType.COURSE_ASSIGNMENT">
        <b-col cols="12">
          <div class="course-assignment-section p-3 mb-3">
            <h6 class="text-primary mb-3">
              <i class="fa fa-graduation-cap"></i>
              Determinação de Curso Obrigatório
            </h6>

            <b-form-group label="Selecionar Denunciado *">
              <b-form-select
                v-model="selectedDenouncedId"
                v-validate="'required'"
                class="form-control"
                :options="denouncedOptions"
                aria-describedby="invalidDenouncedSelect"
                name="denouncedSelect"
                :state="validateState('denouncedSelect')"
                @change="onDenouncedSelected"
              ></b-form-select>
              <b-form-invalid-feedback id="invalidDenouncedSelect">
                {{ errors.first("denouncedSelect") }}
              </b-form-invalid-feedback>
              <small v-if="loadingDenounced" class="text-muted">
                <i class="fa fa-spinner fa-spin"></i> Carregando investigados...
              </small>
              <small
                v-if="denouncedList.length === 0 && !loadingDenounced"
                class="text-warning d-block mt-1"
              >
                <i class="fa fa-exclamation-triangle"></i> Nenhum denunciado
                cadastrado nesta denúncia
              </small>
            </b-form-group>

            <b-form-group label="Nome do Denunciado *">
              <b-form-input
                v-model="event.courseAssignment.denouncedName"
                v-validate="rules.courseAssignment.denouncedName"
                class="form-control"
                placeholder="Nome completo"
                aria-describedby="invalidDenouncedName"
                name="denouncedName"
                :state="validateState('denouncedName')"
                :readonly="!!selectedDenouncedId"
              ></b-form-input>
              <b-form-invalid-feedback id="invalidDenouncedName">
                {{ errors.first("denouncedName") }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Email do Denunciado *">
              <b-form-input
                v-model="event.courseAssignment.denouncedEmail"
                v-validate="rules.courseAssignment.denouncedEmail"
                class="form-control"
                type="email"
                placeholder="email@exemplo.com"
                aria-describedby="invalidDenouncedEmail"
                name="denouncedEmail"
                :state="validateState('denouncedEmail')"
              ></b-form-input>
              <b-form-invalid-feedback id="invalidDenouncedEmail">
                {{ errors.first("denouncedEmail") }}
              </b-form-invalid-feedback>
              <small v-if="showEmailWarning" class="text-danger d-block mt-1">
                <i class="fa fa-exclamation-triangle"></i> Atenção: O e-mail não
                está cadastrado no sistema. Por favor, digite o e-mail
                manualmente.
              </small>
              <small class="text-muted"
                >O email será usado para enviar as credenciais de acesso ao
                curso</small
              >
            </b-form-group>

            <b-form-group label="CPF do Denunciado">
              <b-form-input
                v-model="event.courseAssignment.denouncedCPF"
                v-mask="'###.###.###-##'"
                class="form-control"
                placeholder="000.000.000-00"
                name="denouncedCPF"
                :readonly="
                  !!selectedDenouncedId && !!event.courseAssignment.denouncedCPF
                "
              ></b-form-input>
            </b-form-group>

            <b-form-group label="Curso Obrigatório *">
              <b-form-select
                v-model="event.courseAssignment.courseId"
                v-validate="rules.courseAssignment.courseId"
                class="form-control"
                :options="eadCoursesOptions"
                aria-describedby="invalidCourseId"
                name="courseId"
                :state="validateState('courseId')"
                @focus="loadEADCourses"
              ></b-form-select>
              <b-form-invalid-feedback id="invalidCourseId">
                {{ errors.first("courseId") }}
              </b-form-invalid-feedback>
              <small v-if="loadingCourses" class="text-muted">
                <i class="fa fa-spinner fa-spin"></i> Carregando cursos...
              </small>
              <small v-if="eadCoursesError" class="text-danger d-block mt-1">
                <i class="fa fa-exclamation-triangle"></i> {{ eadCoursesError }}
              </small>
            </b-form-group>

            <b-alert show variant="info" class="mt-3 mb-0">
              <i class="fa fa-info-circle"></i>
              <strong>O sistema irá automaticamente:</strong>
              <ul class="mb-0 mt-2 pl-3">
                <li>Criar ou localizar o usuário no sistema EAD</li>
                <li>Matricular automaticamente no curso selecionado</li>
                <li>
                  Enviar email com credenciais de acesso (se novo usuário)
                </li>
                <li>Enviar link direto para o curso</li>
                <li>Notificar quando o curso for concluído</li>
              </ul>
            </b-alert>

            <b-alert
              v-if="eadHealthCheck.checked"
              :variant="eadHealthCheck.healthy ? 'success' : 'warning'"
              show
              class="mt-2 mb-0"
            >
              <i
                :class="
                  eadHealthCheck.healthy
                    ? 'fa fa-check-circle'
                    : 'fa fa-exclamation-triangle'
                "
              ></i>
              {{ eadHealthCheck.message }}
            </b-alert>
          </div>
        </b-col>
      </b-row>
      <b-row
        v-if="[EventType.WITH_ATTACHMENT, EventType.TASK].includes(event.type)"
      >
        <b-col cols="12">
          <b-form-group
            label="Anexo"
            :state="fileValidated"
            invalid-feedback="Adicione um arquivo"
          >
            <single-file-upload
              ref="upload"
              :post-action="upload.postAction"
              :data="upload.data"
              :disabled="uploading || uploadComplete"
              @upload-complete="onProcessingFinished"
              @file-changed="validateFile()"
            >
            </single-file-upload>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="event.type !== EventType.TIME_COST">
        <b-col cols="12">
          <b-form-group
            :label="
              event.type === EventType.REOPEN
                ? 'Informar motivo(s) de reabertura'
                : 'Descrição'
            "
          >
            <b-form-textarea
              v-model="event.description"
              v-validate="rules.description"
              type="text"
              class="form-control"
              :rows="4"
              :max-rows="4"
              aria-describedby="invalidDescription"
              name="description"
              :state="validateState('description')"
            ></b-form-textarea>
            <b-form-invalid-feedback id="invalidDescription">
              {{ errors.first("description") }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-alert :show="event.type === EventType.CLOSURE" variant="warning"
            >Após salvar o status como concluída, será necessário reabrir a
            denúncia para inserir novas informações.</b-alert
          >
          <b-alert :show="event.type === EventType.CLOSURE" variant="warning">
            Antes de encerrar, adicione a mensagem de conclusão para o
            comunicante (acompanhamento externo).
          </b-alert>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import ComplaintStatus from "../../../../backend/models/ComplaintStatus.ts";
import EventType from "../../../../backend/models/EventType.ts";
import { createEvent } from "../../api/complaint";
import SingleFileUpload from "../../components/SingleFileUpload";
import moment from "moment";
import { getCompanyUsers } from "../../api/company";
import { mapGetters } from "vuex";
import { mask } from "vue-the-mask";
import request from "../../utils/request";

export default {
  name: "EventModal",
  components: { SingleFileUpload },
  directives: { mask },
  props: {
    complaint: {
      type: Object,
      default: null,
    },
    pendency: {
      type: Object,
      default: null,
    },
    task: {
      type: Object,
      default: null,
    },
  },
  data() {
    const classification = Object.assign(
      {},
      {
        receivingMeans: null,
        channelConfidence: null,
        origin: null,
        reportingAgent: null,
        level: null,
        nature: null,
        responsibleDepartment: null,
        involvedDepartment: null,
        businessUnit: null,
        businessGroup: null,
        complaintClosure: null,
        relatedProject: null,
      },
      this.complaint.classification
    );
    const companyClassification = Object.assign(
      {},
      {
        receivingMeans: { enabled: false, portalEnabled: false },
        channelConfidence: { enabled: false, portalEnabled: false },
        origin: { enabled: false, portalEnabled: false },
        reportingAgent: { enabled: false, portalEnabled: false },
        level: { enabled: false, portalEnabled: false },
        nature: { enabled: false, portalEnabled: false },
        responsibleDepartment: { enabled: false, portalEnabled: false },
        involvedDepartment: { enabled: false, portalEnabled: false },
        businessUnit: { enabled: false, portalEnabled: false },
        businessGroup: { enabled: false, portalEnabled: false },
        complaintClosure: { enabled: false, portalEnabled: false },
        relatedProject: { enabled: false, portalEnabled: false },
      },
      this.complaint.company.classification
    );

    return {
      classification,
      companyClassification,
      minDeadline: moment().format("YYYY-MM-DD"),
      EventType,
      typeOpts: [],
      event: {
        type: EventType.FREE_TEXT,
        pendency: { user: null },
        task: { email: null },
        timeCost: {
          timeSpent: null,
          cost: null,
          description: null,
        },
        courseAssignment: {
          denouncedName: "",
          denouncedEmail: "",
          denouncedCPF: "",
          courseId: "",
        },
      },
      uploading: false,
      uploadComplete: false,
      fileValidated: true,
      companyUsers: [],
      managedByCompanyUsers: [],
      userOpts: [],
      upload: {
        postAction: "",
        data: {},
      },
      saving: false,
      lastResponse: null, // Para guardar resposta da criação do evento
      // Dados para integração EAD
      eadCourses: [],
      loadingCourses: false,
      eadCoursesError: null,
      eadHealthCheck: {
        checked: false,
        healthy: false,
        message: "",
      },
      // Dados dos denunciados
      denouncedList: [],
      loadingDenounced: false,
      selectedDenouncedId: null,
      showEmailWarning: false,
    };
  },
  computed: {
    ...mapGetters(["profile", "classificationOptions"]),
    modalTitle() {
      if (this.pendency) {
        return `Resolução de pendência da movimentação #${this.pendency.number}`;
      }
      if (this.task) {
        return `Resolução de tarefa de terceiros da movimentação #${this.task.number}`;
      }
      return "Adicionar Movimentação";
    },
    eadCoursesOptions() {
      console.log(
        "🔍 [Frontend] Construindo opções de cursos:",
        this.eadCourses
      );
      const options = [
        {
          value: "",
          text: this.loadingCourses
            ? "Carregando cursos..."
            : "Selecione um curso...",
        },
      ];
      this.eadCourses.forEach((course) => {
        console.log("🔍 [Frontend] Curso:", course);
        options.push({
          value: course._id,
          text:
            course.nome + (course.subtitulo ? ` - ${course.subtitulo}` : ""),
        });
      });
      console.log("🔍 [Frontend] Opções finais:", options);
      return options;
    },
    denouncedOptions() {
      const options = [
        {
          value: null,
          text: this.loadingDenounced
            ? "Carregando investigados..."
            : "Selecione um denunciado...",
        },
      ];
      this.denouncedList.forEach((denounced) => {
        options.push({
          value: denounced._id,
          text: denounced.displayName,
        });
      });
      return options;
    },
    rules() {
      return {
        type: { required: true },
        description: {
          required: this.event.type !== EventType.TIME_COST,
        },
        closure: {
          required: this.event.type === EventType.CLOSURE,
        },
        pendency: {
          user: {
            required: !!this.event.pendency.dueDate,
          },
          dueDate: {
            required: false,
          },
        },
        task: {
          email: {
            required: this.event.type === EventType.TASK,
            email: true,
          },
          dueDate: {
            required: this.event.type === EventType.TASK,
          },
        },
        timeCost: {
          timeSpent: {
            required: this.event.type === EventType.TIME_COST,
            min_value: 0,
          },
          cost: {
            required: this.event.type === EventType.TIME_COST,
            min_value: 0,
          },
          description: {
            required: this.event.type === EventType.TIME_COST,
          },
        },
        courseAssignment: {
          denouncedName: {
            required: this.event.type === EventType.COURSE_ASSIGNMENT,
          },
          denouncedEmail: {
            required: this.event.type === EventType.COURSE_ASSIGNMENT,
            email: true,
          },
          courseId: {
            required: this.event.type === EventType.COURSE_ASSIGNMENT,
          },
        },
      };
    },
  },
  watch: {
    "event.timeCost.timeSpent"(newTimeSpent) {
      if (
        this.event.type === EventType.TIME_COST &&
        newTimeSpent !== null &&
        newTimeSpent !== undefined
      ) {
        const hourlyRate = this.complaint.company?.financial?.hourlyRate;
        if (hourlyRate) {
          this.event.timeCost.cost = parseFloat(
            ((newTimeSpent / 60) * hourlyRate).toFixed(2)
          );
        }
      }
    },
    "event.type"(newType) {
      console.log("🔍 [Frontend] Tipo de evento alterado para:", newType);
      if (newType === EventType.COURSE_ASSIGNMENT) {
        console.log(
          "🔍 [Frontend] Carregando cursos e denunciados automaticamente..."
        );
        // Verificar se módulo está habilitado antes de fazer chamadas
        const coursesEnabled = this.$store.getters.modules?.courses?.enabled;
        if (coursesEnabled) {
          this.loadEADCourses();
          // Remover health check pois o endpoint não existe
          // this.checkEADHealth();
        } else {
          console.log("⚠️ [Frontend] Módulo de cursos desabilitado");
        }
        this.loadDenounced();
      }
    },
  },
  methods: {
    validateState(ref) {
      if (
        this.vFields[ref] &&
        (this.vFields[ref].dirty || this.vFields[ref].validated)
      ) {
        return !this.errors.has(ref);
      }
      return null;
    },

    validateFile() {
      if ([EventType.WITH_ATTACHMENT].includes(this.event.type)) {
        const file = this.$refs.upload.selectedFile();
        this.fileValidated = !!file;
      }
    },
    async onSaveClicked(bvEvt) {
      bvEvt.preventDefault();
      if (this.saving) {
        return;
      }
      this.saving = true;
      await this.processSave();
    },
    async processSave() {
      const validated = await this.$validator.validateAll();
      this.validateFile();

      if (!validated || !this.fileValidated) {
        this.saving = false;
        return;
      }

      let response;
      try {
        response = await createEvent(this.complaint._id, this.event);
      } catch (error) {
        this.saving = false;
        if (error.response.status / 100 === 4) {
          this.$bvToast.toast(
            error.response.data || "Não foi possível adicionar a movimentação.",
            {
              title: "Erro",
              toastClass: "custom-toast custom-toast-error",
              variant: "light",
              solid: true,
              autoHideDelay: 10000,
              noCloseButton: false,
            }
          );
        } else {
          this.$bvToast.toast(
            error.response.statusText ||
              "Não foi possível adicionar a movimentação.",
            {
              title: "Erro",
              toastClass: "custom-toast custom-toast-error",
              variant: "light",
              solid: true,
              autoHideDelay: 10000,
              noCloseButton: false,
            }
          );
        }
        return;
      }

      if (
        [EventType.WITH_ATTACHMENT, EventType.TASK].includes(this.event.type)
      ) {
        const event = response.data;
        this.uploading = true;
        this.lastResponse = response; // Guardar resposta para usar depois do upload

        const file = this.$refs.upload.selectedFile();
        if (file) {
          this.upload.postAction = `/api/complaints/${this.complaint._id}/events/${event._id}/file`;
          file.postAction = this.upload.postAction;
          file.headers = this.upload.headers;

          this.$nextTick(() => this.$refs.upload.start());
        } else {
          this.onProcessingFinished(response);
        }
      } else {
        this.onProcessingFinished(response);
      }
    },

    onProcessingFinished(response) {
      this.uploadComplete = true;
      this.uploading = false;

      // Se não foi passada resposta, usar a última guardada
      if (!response && this.lastResponse) {
        response = this.lastResponse;
        this.lastResponse = null;
      }

      this.$bvToast.toast("A movimentação foi registrada no sistema.", {
        title: "Sucesso",
        toastClass: "custom-toast custom-toast-success",
        variant: "light",
        solid: true,
        autoHideDelay: 5000,
        noCloseButton: false,
      });
      this.$emit("new-event");

      if (this.event.type === EventType.CLOSURE) {
        this.$emit("status-changed", ComplaintStatus.CONCLUDED);
      } else {
        this.$emit("status-changed", ComplaintStatus.PROCESSING);
      }

      this.$refs.modal.hide();
      this.uploadComplete = false;
      this.saving = false;
    },

    async loadUserOpts() {
      const companyId = this.complaint.company._id || this.complaint.company;
      const response = await getCompanyUsers(companyId, true);
      this.companyUsers = response.data || [];

      // Garantir inicialização do array
      this.managedByCompanyUsers = [];

      if (this.complaint.company.managedBy) {
        const managedResponse = await getCompanyUsers(
          this.complaint.company.managedBy,
          true
        );
        this.managedByCompanyUsers = managedResponse.data || [];
      }

      const userOpts = [];

      const getUserName = (id) => {
        let user = this.companyUsers.find((e) => e._id === id);
        if (user) {
          return `${user.name} ${user.surname}`;
        }
        user = this.managedByCompanyUsers.find((e) => e._id === id);
        if (user) {
          return `${user.name} ${user.surname}`;
        }
        // Se não encontrou o usuário, retornar um valor padrão
        return "Usuário não encontrado";
      };
      const myId = this.profile._id;
      let addedSelf = false;
      if (this.complaint.committee) {
        if (this.complaint.committee.users) {
          for (const id of this.complaint.committee.users) {
            if (id === myId) {
              addedSelf = true;
            }
            userOpts.push({
              value: id,
              text: getUserName(id),
            });
          }
        }
        if (this.complaint.committee.admin) {
          const admin = this.complaint.committee.admin;
          if (admin === myId) {
            addedSelf = true;
          }
          userOpts.push({
            value: admin,
            text: getUserName(admin),
          });
        }
      }
      if (!addedSelf && !!this.profile.company) {
        userOpts.unshift({ value: myId, text: getUserName(myId) });
      }
      userOpts.unshift({ value: null, text: "" });
      this.userOpts = userOpts;
    },

    async loadEADCourses() {
      // Verificar se o módulo de cursos está habilitado
      const coursesEnabled = this.$store.getters.modules?.courses?.enabled;
      if (!coursesEnabled) {
        console.log(
          "⚠️ [Frontend] Módulo de cursos desabilitado - não carregando cursos EAD"
        );
        return;
      }

      // Se já carregou, não carregar novamente
      if (this.eadCourses.length > 0) {
        console.log(
          "🔍 [Frontend] Cursos já carregados:",
          this.eadCourses.length
        );
        return;
      }

      console.log("🔍 [Frontend] Iniciando carregamento de cursos...");
      this.loadingCourses = true;
      this.eadCoursesError = null;

      try {
        console.log("🔍 [Frontend] Fazendo requisição GET /api/ead/courses");
        const response = await request.get("/ead/courses");
        console.log("🔍 [Frontend] Resposta recebida:", response);
        console.log("🔍 [Frontend] Status:", response.status);
        console.log("🔍 [Frontend] Data:", response.data);

        this.eadCourses = response.data;
        console.log("✅ [Frontend] Cursos carregados:", this.eadCourses.length);

        if (this.eadCourses.length === 0) {
          console.warn("⚠️ [Frontend] Nenhum curso disponível");
          this.eadCoursesError = "Nenhum curso disponível no momento";
        }
      } catch (error) {
        console.error("❌ [Frontend] Erro ao carregar cursos do EAD:", error);
        console.error("❌ [Frontend] Error response:", error.response);
        console.error("❌ [Frontend] Error message:", error.message);
        this.eadCoursesError =
          "Erro ao carregar cursos. Verifique a integração com o EAD.";
        this.$bvToast.toast("Não foi possível carregar a lista de cursos.", {
          title: "Erro",
          toastClass: "custom-toast custom-toast-error",
          variant: "light",
          solid: true,
          autoHideDelay: 8000,
          noCloseButton: false,
        });
      } finally {
        this.loadingCourses = false;
        console.log("🔍 [Frontend] Carregamento finalizado");
      }
    },

    async loadDenounced() {
      console.log(
        "🔍 [Frontend] Carregando denunciados da denúncia:",
        this.complaint._id
      );
      this.loadingDenounced = true;

      try {
        const response = await request.get(
          `/denounced/by-complaint/${this.complaint._id}`
        );
        this.denouncedList = response.data;
        console.log(
          "✅ [Frontend] Denunciados carregados:",
          this.denouncedList.length
        );
      } catch (error) {
        console.error("❌ [Frontend] Erro ao carregar denunciados:", error);
        this.$bvToast.toast(
          "Não foi possível carregar a lista de investigados.",
          {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 8000,
            noCloseButton: false,
          }
        );
      } finally {
        this.loadingDenounced = false;
      }
    },

    onDenouncedSelected(denouncedId) {
      console.log("🔍 [Frontend] Denunciado selecionado:", denouncedId);

      if (!denouncedId) {
        // Limpar campos se desmarcou
        this.event.courseAssignment.denouncedName = "";
        this.event.courseAssignment.denouncedEmail = "";
        this.event.courseAssignment.denouncedCPF = "";
        this.showEmailWarning = false;
        return;
      }

      const denounced = this.denouncedList.find((d) => d._id === denouncedId);
      if (denounced) {
        console.log(
          "✅ [Frontend] Preenchendo dados do denunciado:",
          denounced
        );
        this.event.courseAssignment.denouncedName = denounced.name || "";
        this.event.courseAssignment.denouncedCPF = denounced.cpfcnpj || "";

        if (denounced.email) {
          this.event.courseAssignment.denouncedEmail = denounced.email;
          this.showEmailWarning = false;
        } else {
          this.event.courseAssignment.denouncedEmail = "";
          this.showEmailWarning = true;
          this.$bvToast.toast(
            "Atenção: E-mail não encontrado no cadastro do denunciado. Por favor, preencha manualmente.",
            {
              title: "E-mail não cadastrado",
              toastClass: "custom-toast custom-toast-warning",
              variant: "light",
              solid: true,
              autoHideDelay: 6000,
              noCloseButton: false,
            }
          );
        }
      }
    },

    async checkEADHealth() {
      // Verificar se o módulo de cursos está habilitado
      const coursesEnabled = this.$store.getters.modules?.courses?.enabled;
      if (!coursesEnabled) {
        console.log(
          "⚠️ [Frontend] Módulo de cursos desabilitado - não verificando saúde do EAD"
        );
        return;
      }

      console.log("🔍 [Frontend] Verificando saúde da integração EAD...");
      try {
        const response = await request.get("/ead/health");
        console.log("🔍 [Frontend] Health check response:", response.data);
        this.eadHealthCheck = {
          checked: true,
          healthy: response.data.healthy,
          message: response.data.message,
        };
        console.log(
          "✅ [Frontend] Health check:",
          this.eadHealthCheck.healthy ? "OK" : "FALHOU"
        );
      } catch (error) {
        console.error("❌ [Frontend] Erro no health check:", error);
        this.eadHealthCheck = {
          checked: true,
          healthy: false,
          message: "Não foi possível verificar a integração com o EAD",
        };
      }
    },

    async show() {
      await this.loadUserOpts();
      this.event = {
        type: 1,
        pendency: { user: null },
        task: { email: null },
        timeCost: {
          timeSpent: null,
          cost: null,
          description: null,
        },
        courseAssignment: {
          denouncedName: "",
          denouncedEmail: "",
          denouncedCPF: "",
          courseId: "",
        },
      };
      this.selectedDenouncedId = null;
      this.denouncedList = [];
      this.showEmailWarning = false;

      if (this.pendency) {
        this.event.pendency.resolves = this.pendency._id;
      }
      if (this.task) {
        this.event.task.resolves = this.task._id;
      }
      if (this.complaint.status === ComplaintStatus.CONCLUDED) {
        this.typeOpts = [
          { value: EventType.REOPEN, text: "Reabrir procedimento" },
        ];
      } else {
        this.typeOpts = [
          { value: EventType.FREE_TEXT, text: "Texto livre" },
          { value: EventType.WITH_ATTACHMENT, text: "Com anexo" },
          { value: EventType.PENDENCY, text: "Pendência Interna" },
          { value: EventType.TASK, text: "Tarefa de Terceiros" },
          { value: EventType.TIME_COST, text: "Tempo/Recursos" },
          { value: EventType.CLOSURE, text: "Encerramento da Denúncia" },
        ];

        // Adicionar opção de determinação de curso apenas se o módulo estiver habilitado
        const coursesEnabled = this.$store.getters.modules?.courses?.enabled;
        if (coursesEnabled) {
          this.typeOpts.splice(5, 0, {
            value: EventType.COURSE_ASSIGNMENT,
            text: "Determinação de Curso",
          });
        }
      }

      // Não pré-carregar cursos - carregar apenas quando selecionar "Determinação de Curso"
      // Isso evita chamadas desnecessárias ao servidor EAD

      this.$refs.modal.show();
    },
  },
};
</script>

<style scoped>
.course-assignment-section {
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.course-assignment-section h6 {
  color: #667eea;
  font-weight: 600;
}

.course-assignment-section .alert ul {
  font-size: 0.9rem;
}
</style>
